// extracted by mini-css-extract-plugin
export default {"emptyBody":"emptyBody--z61xA","mainContent":"mainContent--tr7TO"};